var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"event-list"},_vm._l((_vm.futureEvents),function(event){return _c('li',[_c('MyEvent',{attrs:{"event":event}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }